import React from 'react';
import { Tooltip } from 'primereact/tooltip';
import { ConnectionStatus } from 'stores/WebSocketStore';
import classes from './websocketStatusIndicator.module.scss';

interface WebSocketStatusIndicatorProps {
  status: ConnectionStatus;
  reconnectAttempts?: number;
  lastError?: string | null;
  className?: string;
}

const WebSocketStatusIndicator: React.FC<WebSocketStatusIndicatorProps> = ({
  status,
  reconnectAttempts = 0,
  lastError = null,
  className = '',
}) => {
  const getStatusColor = (): string => {
    switch (status) {
      case 'connected':
        return classes.green;
      case 'connecting':
      case 'reconnecting':
        return classes.yellow;
      case 'failed':
        return classes.red;
      default:
        return classes.gray;
    }
  };

  const getStatusText = (): string => {
    switch (status) {
      case 'connected':
        return 'WebSocket Connected';
      case 'connecting':
        return 'Connecting...';
      case 'reconnecting':
        return `Reconnecting... (Attempt ${reconnectAttempts})`;
      case 'failed':
        return 'Connection Failed';
      default:
        return 'Disconnected';
    }
  };

  const getTooltipText = (): string => {
    let text = getStatusText();
    if (lastError && status !== 'connected') {
      text += `\nError: ${lastError}`;
    }
    return text;
  };

  const isPulsing = status === 'connecting' || status === 'reconnecting';

  return (
    <>
      <Tooltip target=".websocket-status-indicator" content={getTooltipText()} position="bottom" />
      <div
        className={`websocket-status-indicator ${classes.statusIndicator} ${getStatusColor()} ${isPulsing ? classes.pulsing : ''} ${className}`}
        title={getTooltipText()}
      />
    </>
  );
};

export default WebSocketStatusIndicator;
